module.exports = __webpack_public_path__ + "static/media/hands_10.de9916df.svg";